import { IconStyled } from '@procurify/ui'
import { IconComponentStyled } from '@procurify/ui'
import styled from 'styled-components'

interface IOrderItemTypeTagStyledProps {}

export const OrderItemTypeTagStyled = styled.div<IOrderItemTypeTagStyledProps>``
